import { PRIMARY_KEY } from "@constants/app.constants";
import { formatDateUtil } from "@utils/date.util";

const keyColumn = PRIMARY_KEY;
const tableTitle = "Settings";
const menuUrl = "system/settings";
const tableColumn = [
  {
    id: "setting_name",
    numeric: false,
    disablePadding: true,
    label: "Setting Name",
    sort: true,
  },
  {
    id: "setting_value",
    numeric: false,
    disablePadding: false,
    label: "Setting Value",
    sort: true,
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDateUtil,
    sort: true,
  },
];
const breadCrumbs = [
  { name: "System", menu_url: null },
  { name: "Settings", menu_url: "/system/settings" },
];

const filters = [
  {
    name: "setting_name",
    id: "setting_name",
    label: "Setting Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  {
    name: "setting_value",
    id: "setting_value",
    label: "Setting Value",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  {
    name: "modules",
    id: "modules",
    label: "Modules",
    value: [],
    isMultiple: true,
    options: [
      {
        name: "option 1",
        value: 1,
      },
      {
        name: "option 2",
        value: 2,
      },
    ],

    type: "AUTOCOMPLETE",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

const additionalActions = ({ handleViewDetail }) => [
  {
    name: "View Details",
    icon: "eye",
    buttonClass: "btn btn-outline-info btn-sm",
    onClick: handleViewDetail,
  },
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
  additionalActions,
};
